<template>
  <div id="pc_mall_intact">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'pc_mall_intact'
}
</script>

<style>
  #pc_mall_intact {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/pc_mall_intact/pc_mall_intact.vue